module.exports = __webpack_public_path__ + "static/media/icon_arrow_right.f844db6d.svg";